import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SubjectsPage.css";
import Header from "../components/Header";
import Footer from "../components/Footer";

const SubjectsPage = () => {
  const [classesData, setClassesData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const navigate = useNavigate();

  useEffect(() => {
    fetch("https://mocktest.bbmclasses.com/api/get_subjects.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setClassesData(data.classes);
        }
      });
  }, []);

  const goToSubject = (subjectId) => {
    navigate(`/mocktests/${subjectId}`);
  };

  return (
  <> 
  <Header/>
    <div className="subjects-page">

      {/* TITLE */}
      <div className="page-title">
          <h3>
📘 Objective Question Practice</h3>
          <p className="page-subtitle">
            Choose subject to start practice <br />
            <span>प्रैक्टिस शुरू करने के लिए विषय चुनें</span>
          </p>
        </div>

      {/* FILTER */}
      <div className="filter-box">
        <select
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          <option value="All">All Classes</option>
          {classesData.map((cls) => (
            <option key={cls.id} value={cls.class_name}>
              {cls.class_name}
            </option>
          ))}
        </select>
      </div>

      {/* SUBJECTS */}
      {classesData
        .filter(
          (cls) =>
            selectedCategory === "All" ||
            cls.class_name === selectedCategory
        )
        .map((cls) => (
          <div key={cls.id} className="class-section">

            <h4 className="class-title">{cls.class_name}</h4>

            <div className="subject-scroll">
              {cls.subjects.map((subj) => (
                <div
                  key={subj.id}
                  className="subject-card"
                  onClick={() => goToSubject(subj.id)}
                >
                  <div className="image-wrapper">
                    <img
                      src={subj.subject_image}
                      alt={subj.subject_name}
                    />
                    <div className="overlay">▶</div>
                  </div>

                  <div className="subject-name">
                    {subj.subject_name}
                  </div>
                </div>
              ))}
            </div>

          </div>
        ))}
    </div>
    <Footer/>
    </>
  );
};

export default SubjectsPage;